<script setup lang="ts">
import { parseQcAbnahmeAnswers } from "@/utils/parse-qc-abnahme-answers";
import QuestionnaireAnswerReview from "../Questionnaire/parts/QuestionnaireAnswerReview.vue";
import QuestionnaireFinalScreen from "../Questionnaire/parts/QuestionnaireFinalScreen.vue";
import QuestionnaireModal from "../Questionnaire/parts/QuestionnaireModal.vue";
import { defineEmits, defineProps, computed } from "vue";
import QuestionnaireProgressBar from "../Questionnaire/parts/QuestionnaireProgressBar.vue";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  isAbnahmeQcModalOpen: boolean;
  currentPhaseProgress: any;
};

const props = defineProps<Props>();

type Emits = {
  (event: "onClose"): void;
};
const emits = defineEmits<Emits>();
const isModalOpen = computed(() => props.isAbnahmeQcModalOpen);
const { t } = useTranslate();

const metadata = computed(() => {
  let tempMetadata: any = [];
  let qcActions = props.currentPhaseProgress?.qcActions;
  if (qcActions[0].metadata) {
    let type: "qc" | "abnahme" | "appointment" = "qc";
    if (qcActions[0].action === 1) {
      type = "appointment";
    } else if ([2, 3, 4].includes(qcActions[0].action)) {
      type = "abnahme";
    } else {
      type = "qc";
    }
    if (qcActions && qcActions[0].metadata) {
      tempMetadata = parseQcAbnahmeAnswers(qcActions[0].metadata, type);
    }
  } else if (qcActions[0].description) {
    tempMetadata.push({
      question: t("questionnaire.what_data_is_missing").value,
      answer: qcActions[0].description,
    });
  }

  return tempMetadata;
});
</script>
<template>
  <Transition name="nested">
    <div v-if="isModalOpen">
      <div
        class="w-full h-screen fixed top-0 left-0 flex items-start justify-center bg-black/75 z-[1000]"
      >
        <QuestionnaireModal class="modal" @on-close="$emit('onClose')">
          <template #header>
            <div class="flex gap-2 items-center">
              <img
                class="w-4 h-4 cursor-pointer"
                src="@/assets/pencil-gray.svg"
                alt="Pencil"
              />
              <h2 class="text-xl font-semibold">
                {{ t("phase.review") }}
                {{
                  currentPhaseProgress.phaseStatus.id === 8 ? "QC" : "Abnahme"
                }}
              </h2>
            </div>
          </template>
          <template #progress-bar>
            <QuestionnaireProgressBar :progress="100" :warning="true" />
          </template>
          <template #content>
            <QuestionnaireFinalScreen
              :title="t('questionnaire.submit').value"
              sub-title=""
              status="waiting"
            />
            <div v-if="metadata && metadata.length > 0">
              <QuestionnaireAnswerReview :answers="metadata" />
            </div>
            <div></div>
          </template>
        </QuestionnaireModal>
      </div>
    </div>
  </Transition>
</template>
